import React from "react";
import styles from "./YearlyTable.module.scss";
import { Loader } from "../Loader";

const YearlyTable = ({ plants, headerName = 'Plant/ Month' }) => {
  const mainHeaders = Array.from(
    new Set(plants.flatMap((plant) => plant.data.map((entry) => entry.header)))
  );

  // Extract subheaders dynamically
  const subHeaders = {};
  plants.forEach((plant) => {
    plant.data.forEach((entry) => {
      subHeaders[entry.header] = Object.keys(entry.monthly_plant_data);
    });
  });

  return (
    <div className={styles.yearlyTableDiv}>
      {!Array.isArray(plants) ? (
        <div className={styles.containers}>
          <Loader />
        </div>
      ) : (
        <table className={styles.tableComponent}>
          <thead className={styles.tableContainer}>
            <tr className={styles.tableContainerHeaderRowMain}>
              <th>#</th>
              <th>{headerName}</th>
              {mainHeaders.map((header) => (
                <th key={header} colSpan={subHeaders[header].length}>
                  {header}
                </th>
              ))}
            </tr>
            <tr className={styles.tableContainerHeaderRow}>
              <th></th>
              <th></th>
              {mainHeaders.map((header) =>
                subHeaders[header].map((subHeader) => (
                  <th className={styles.cellsDataLeft} key={subHeader}>
                    {subHeader}
                  </th>
                ))
              )}
            </tr>
          </thead>
          {/* </div> */}
          <tbody>
            {plants.map((plant, index) => (
              <tr
                key={plant.plant_name}
                className={styles.tableContainerHeaderRow}
              >
                <td className={plant?.plant_name?.includes("- Total") ? styles.totalCell : ''}>{index + 1}</td>
                <td className={plant?.plant_name?.includes("- Total") ? styles.totalCell : ''}>{plant.plant_name}</td>
                {mainHeaders.map((header) =>
                  plant.data
                    .filter((entry) => entry.header === header)
                    .map((entry, entryIndex) =>
                      subHeaders[header].map((subHeader, subHeaderIndex) => (
                        <td className={plant?.plant_name?.includes("- Total") ? styles.totalCell : styles.cellData} key={subHeaderIndex}>
                          {entry.monthly_plant_data[subHeader] !== undefined
                            ? entry.monthly_plant_data[subHeader]
                            : "-"}
                        </td>
                      ))
                    )
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default YearlyTable;
